<div class="mr-b--md" *ngIf="loadedData">
    <div class="table--grid__header">
        {{ 'Documentation suicidality' | translate }}
    </div>
    <div class="table--grid__body hv--n">
            <div class="form-section">
                <div class="row br--n  mr-t--md  mr-b--md">
                    <div class="col-xs-2">
                        <mat-label class="suidicality__label">{{ SuicidalityColumns[1][1] | translate }}</mat-label>
                        <mat-select [placeholder]="" (ngModelChange)="setTypeSuicidal($event)"
                                    [(ngModel)]="selectedSuicidal">
                            <mat-option selected [value]="false"> {{ 'No' | translate}} </mat-option>
                            <mat-option [value]="true"> {{ 'Yes' | translate}} </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-xs-5">
                        <mat-label class="suidicality__label">{{ SuicidalityColumns[2][1] | translate }}</mat-label>
                        <mat-select [(ngModel)]="selectedTypeSuicidal" [disabled]="!selectedSuicidal">
                            <ng-container *ngFor="let type of SuicidalityTypes; let i = index">
                                <mat-option *ngIf="(i === 0 && !selectedSuicidal) || i > 0" [value]="type.value">
                                    {{type.text | translate}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </div>
                    <div class="col-xs-3">
                        <mat-label class="suidicality__label">{{ SuicidalityColumns[3][1] | translate }}</mat-label>
                        <mat-select [(ngModel)]="selectedCredibly" [disabled]="!selectedSuicidal">
                            <mat-option selected value="" *ngIf="!selectedSuicidal"> - </mat-option>
                            <mat-option [value]="false"> {{ 'No' | translate}} </mat-option>
                            <mat-option [value]="true"> {{ 'Yes' | translate}} </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-xs-2">
                        <button (click)="add()" class="btn btn-primary btn-add-diagnosis btn-icon btn-icon--left pull-left" type="button">
                            <i class="fal fa-plus"></i>
                            {{ 'Add new entry' | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="row table--grid__body--header mr-t--sm">
                <div class="col-xs-11">
                    <div class="row">
                        <div *ngFor="let column of SuicidalityColumns" class="{{ column[2] }}">
                            {{ column[1] | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="suicidalities.length">
                <div class="row" *ngFor="let suicidality of suicidalities">
                    <div class="col-xs-11">
                        <div class="row">
                            <div *ngFor="let column of SuicidalityColumns" class="{{ column[2] }}">
                                <ng-container *ngIf="column[0] === 'credibly_distant' || column[0] === 'suicidal'">
                                    <span *ngIf="suicidality[column[0]] != null; else emptySui">
                                        {{ suicidality[column[0]] ? ('Yes' | translate) : ('No' | translate)}}
                                    </span>
                                    <ng-template #emptySui>-</ng-template>
                                </ng-container>
                                <ng-container *ngIf="column[0] === 'type'">
                                    <span>
                                        {{ getSuicidalName(suicidality[column[0]]) | translate}}
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="column[0] === 'updated_at'">
                                    <span>
                                        {{ suicidality[column[0]] | datex:'HH:mm, DD.MM.YYYY' }}
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="column[0] === 'related_domain'">
                                    <div class="related-domain" *ngFor="let domain of suicidality[column[0]]">
                                        {{ domain['name_' + translate.currentLang] }} <span class="separator"> </span>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

            </ng-container>
            <ng-container *ngIf="suicidalities.length === 0">
                <div class="row">
                    <div class="col-xs-11">
                        <div class="row">
                            <div class="col-xs-12 no-item text-center">
                                <span>{{ 'No suicidalities' | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
</div>

<div class="mr-b--md" *ngIf="loadedData">
    <div class="table--grid__header">
        {{ 'Attendance patient' | translate }}
    </div>
    <div class="table--grid__body hv--n">
        <div class="form-section">
            <div class="row br--n mr-b--md mr-t--md">
                <div class="col-xs-10">
                    <div class="row">
                        <div class="col-xs-4">
                            <mat-label class="suidicality__label">{{ InfoCallColumns[1][1] | translate }}</mat-label>
                            <mat-select [(ngModel)]="selectedTypeInfo">
                                <ng-container *ngFor="let type of InfoTypes; let i = index">
                                    <mat-option *ngIf="(i === 0 && !selectedInfoCall) || i > 0" [value]="type.value">
                                        {{type.text | translate}}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-10" *ngIf="selectedTypeInfo === InfoTypes[2]['value']">
                            <app-tinymce #tinymce
                                         [options]="{
                                         toolbar: false,
                                         branding: false
                                         }"
                                         [(ngModel)]='callInfo'
                                         [ngModelOptions]="{standalone: true}"></app-tinymce>
                        </div>
                    </div>
                </div>
                <div class="col-xs-2">
                    <button (click)="addInfoCall()" class="btn btn-primary btn-add-diagnosis btn-icon btn-icon--left pull-left" type="button">
                        <i class="fal fa-plus"></i>
                        {{ 'Add new entry' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <div class="row table--grid__body--header mr-t--sm">
            <div class="col-xs-11">
                <div class="row">
                    <div *ngFor="let column of InfoCallColumns" class="{{ column[2] }}">
                        {{ column[1] | translate }}
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="callInfos && callInfos.length">
            <div class="row info" *ngFor="let info of callInfos">
                <div class="col-xs-11">
                    <div class="row">
                        <div *ngFor="let column of InfoCallColumns" class="{{ column[2] }}">
                            <ng-container *ngIf="column[0] === 'comment'">
                                <span class="info info__notes" [innerHTML]="info[column[0]]"></span>
                            </ng-container>
                            <ng-container *ngIf="column[0] === 'type'">
                                <span>
                                    {{ getInfoType(info[column[0]]) | translate}}
                                </span>
                            </ng-container>
                            <ng-container *ngIf="column[0] === 'updated_at'">
                                <span>
                                    {{ info[column[0]] | datex:'HH:mm, DD.MM.YYYY' }}
                                </span>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

        </ng-container>
        <ng-container *ngIf="callInfos.length === 0">
                <div class="row">
                    <div class="col-xs-11">
                        <div class="row">
                            <div class="col-xs-12 no-item text-center">
                                <span>{{ 'No call information' | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
</div>
